import React from 'react';
import { DeleteOutline as DeleteIcon } from '@mui/icons-material';
import AddIcon from '@mui/icons-material//Add';
import { styled } from '@mui/material';
import { Button, FormGroup, IconButton, InputAdornment } from '@mui/material';
import { ADD_DOCUMENT_REQUEST_BUTTON } from 'common/constants/documents';
import CustomTextField from 'components/CustomTextField';
import theme from 'theme';
import { FileField, RequestFileNameProps } from './RequestFolder.props';

const PREFIX = 'RequestFileName';

const classes = {
  deleteButton: `${PREFIX}-deleteButton`,
  addButton: `${PREFIX}-addButton`,
};

const StyledFormGroup = styled(FormGroup)({
  [`& .${classes.deleteButton}`]: {
    color: `${theme.palette.grey[500]}`,
    marginLeft: 0,
    opacity: 0.3,
    transition: 'ease opacity 1s',
    '&:hover': {
      opacity: 1,
    },
  },
  [`& .${classes.addButton}`]: {
    fontSize: '1rem',
    textTransform: 'none',
    fontWeight: 500,
    borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
    borderRadius: '0',
    '&& .MuiButton-label': {
      justifyContent: 'start',
    },
  },
});

const RequestFileName = ({ formValues, setFormValues, fields, setFields }: RequestFileNameProps) => {
  const addTextField = (): void => {
    setFields([...fields, { fileName: '', error: false }]);
  };

  const setErrorInField = (index: number, error: boolean): void => {
    const newFields = [...fields];
    newFields[index].error = error;
    setFields(newFields);
  };

  const validateFields = (newFields: FileField[], index: number): void => {
    setFields(newFields);
    if (newFields[index]?.fileName !== '') {
      setFormValues({
        ...formValues,
        requested_files: newFields.map(field => ({ fileName: field.fileName, error: field.error })),
      });
    } else {
      setErrorInField(index, true);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, index: number): void => {
    const newFields = [...fields];
    newFields[index].fileName = e.target.value;
    newFields[index].error = false;
    validateFields(newFields, index);
  };

  const handleDelete = (_e: React.MouseEvent, index: number): void => {
    // remove e from fields
    const newFields = [...fields];
    newFields.splice(index, 1);
    validateFields(newFields, index - 1);
  };

  return (
    <StyledFormGroup style={{ marginBottom: '2rem' }}>
      {fields.map((field, index) => (
        <div key={field.id} style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'space-between' }}>
          <CustomTextField
            id="file-requested-name"
            type="text"
            name="fileName"
            label="Name of document requested"
            value={field.fileName}
            onChange={e => handleChange(e, index)}
            onBlur={e => handleChange(e, index)}
            required
            variant="standard"
            error={field.error}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="start" className={classes.deleteButton}>
                  <IconButton onClick={e => handleDelete(e, index)}>
                    <DeleteIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>
      ))}
      <Button className={classes.addButton} startIcon={<AddIcon />} color="primary" onClick={addTextField}>
        {ADD_DOCUMENT_REQUEST_BUTTON}
      </Button>
    </StyledFormGroup>
  );
};

export default RequestFileName;
